import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { arlTableData, determineIfIsArlTableDataOrGroupEnd, groupEndPlaceholder } from '../../arl-table.component';
import {
    AccountsReceivableLedgerEntity, AccountsReceivableLedgerTypeEnum,
} from '../../../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import {
    NumberTransformInputComponent
} from '../../../../../../number-transform-input/number-transform-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { HintIconComponent } from '../../../../../../hint-icon/hint-icon.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { getErrorMessage } from '../../../../../../helper/validation.helper';

@Component({
    selector: 'app-arl-table-cell-base-cost',
    standalone: true,
    imports: [CommonModule, MatLegacyInputModule, NumberTransformInputComponent, ReactiveFormsModule, HintIconComponent, FormsModule, FontAwesomeModule, MatLegacyButtonModule, MatLegacyTooltipModule],
    templateUrl: './arl-table-cell-base-cost.component.html',
    styleUrls: ['./arl-table-cell-base-cost.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'flex items-center' },
})
export class ArlTableCellBaseCostComponent {
    @Input() rowData: arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder;
    @Input() useArlSeparateSalaryBaseCost: boolean;
    @Input() baseCostLabel: string;
    @Input() disabledSurchargeInput: boolean;

    @Output() baseCostChange: EventEmitter<number> = new EventEmitter();
    @Output() costAmountChange: EventEmitter<number> = new EventEmitter();
    @Output() surchargePercentChange: EventEmitter<number> = new EventEmitter();
    @Output() costAmountBlur: EventEmitter<void> = new EventEmitter();
    @Output() priceInformationClick: EventEmitter<void> = new EventEmitter();
    @Output() bidderClick: EventEmitter<void> = new EventEmitter();


    protected readonly getErrorMessage = getErrorMessage;

    protected readonly isNotNullOrUndefined = isNotNullOrUndefined;
    protected readonly determineIfIsArlTableDataOrGroupEnd = determineIfIsArlTableDataOrGroupEnd;
    protected ARLTypeEnumMaterialArl = AccountsReceivableLedgerTypeEnum.MaterialArl;
}
